import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  standalone: false,
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.scss'
})
export class ToggleButtonComponent {

  
  @Input() label:string ="toggle";
  @Input() name:string ="toggle";
  @Input() value:boolean =true;

  constructor() { }

}
